//      
import { find } from '../../../../native-with-fallback';

const supportedEventName         = (()         => {
  const base         = 'visibilitychange';

  // Server side rendering
  if (typeof document === 'undefined') {
    return base;
  }

  // See https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
  const candidates           = [
    base,
    `ms${base}`,
    `webkit${base}`,
    `moz${base}`,
    `o${base}`,
  ];

  const supported          = find(
    candidates,
    (eventName        )          => `on${eventName}` in document,
  );

  return supported || base;
})();

export default supportedEventName;



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/use-sensor-marshal/sensors/util/supported-page-visibility-event-name.js